import styled from 'styled-components';

export const FieldSet = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: none;
  padding: 0;
  margin: 0%;
  > div:last-child {
    margin: 0;
  }
  & + &:not(:first-child) {
    margin-top: 32px;
  }

  @media (max-width: 650px) {
    width: 100%;
  }
`;
